module.exports = __webpack_public_path__ + "static/img/IMG_20170721_134149.7749d56c.jpg";